import { type PageEntry, type Tabs, isTabs } from './types';

export const LENS_TAB_PARAM = 'tab';

export function readLensTabs(search: string = window.location.search): Array<string> {
  return (new URLSearchParams(search).get(LENS_TAB_PARAM) ?? '').split(',').filter(Boolean);
}

export function writeLensTabs(tabs: Array<string>) {
  const url = new URL(window.location.href);
  if (tabs.length) url.searchParams.set(LENS_TAB_PARAM, tabs.join(','));
  else url.searchParams.delete(LENS_TAB_PARAM);
  window.history.replaceState(window.history.state, '', url);
}

export function hasTabs(page: Array<PageEntry>): boolean {
  return page.some(isTabs);
}

export function activeTab(group: Tabs, chosen: Array<string>) {
  return group.tabs.find((tab) => chosen.includes(tab.id)) ?? group.tabs[0];
}

export function shownTabs(page: Array<PageEntry>, chosen: Array<string>): Array<string> {
  return page.flatMap((entry) => {
    if (!isTabs(entry)) return [];
    const tab = activeTab(entry, chosen);
    return tab ? [tab.id, ...shownTabs(tab.page, chosen)] : [];
  });
}

export function shownPage(page: Array<PageEntry>, chosen: Array<string>): Array<PageEntry> {
  return page.flatMap((entry) => (isTabs(entry) ? shownPage(activeTab(entry, chosen)?.page ?? [], chosen) : [entry]));
}

export function groupOf(page: Array<PageEntry>, tabId: string): Tabs | undefined {
  for (const entry of page) {
    if (!isTabs(entry)) continue;
    if (entry.tabs.some((tab) => tab.id === tabId)) return entry;
    for (const tab of entry.tabs) {
      const inner = groupOf(tab.page, tabId);
      if (inner) return inner;
    }
  }
  return undefined;
}

export function choose(group: Tabs, tabId: string, chosen: Array<string>): Array<string> {
  const siblings = new Set(group.tabs.map((tab) => tab.id));
  return [...chosen.filter((id) => !siblings.has(id)), tabId];
}
